

// 定义Action类型
export const SET_URNAME = 'SET_URNAME';

export const SET_SECURITYQUESTION = 'SET_SECURITYQUESTION';